export default __webpack_public_path__ + "static/media/home_content_3.515ba9b0.png";